import React from 'react';
import { useNavigate } from 'react-router-dom';

const PLANS = [
  {
    name: "Basic", price: "$97", period: "/mo",
    desc: "Everything you need to get started with AI-powered outreach.",
    color: "#185FA5", highlight: false,
    features: ["AI conversation handling","CRM with lead tracking","Appointment setting","Email confirmation workflow","Policy breakdown emails","Welcome / premium day emails","Manual agent override","Up to 500 leads/month","Email support"],
  },
  {
    name: "Pro", price: "$197", period: "/mo",
    desc: "Everything in Basic plus automated lead acquisition on autopilot.",
    color: "#534AB7", highlight: true,
    features: ["Everything in Basic","Auto lead scraping","Phone number validation","AI lead enrichment & scoring","Multi-source lead acquisition","Up to 2,000 leads/month","Priority email support","Advanced follow-up sequences","Lead source analytics"],
  },
  {
    name: "Pro+", price: "$497", period: "/mo",
    desc: "Full power for high-volume agents running serious pipelines.",
    color: "#0F6E56", highlight: false,
    features: ["Everything in Pro","Unlimited leads/month","Advanced analytics dashboard","Custom follow-up sequences","A/B message testing","Priority phone support","Dedicated onboarding call","Early access to new features","99.9% uptime SLA"],
  },
];

export default function Pricing() {
  const navigate = useNavigate();

  return (
    <div style={{ minHeight: "100vh", background: "#0e0e0c", color: "#f0efe9" }}>
      <nav style={{ display: "flex", alignItems: "center", justifyContent: "space-between", padding: "20px 48px", borderBottom: "0.5px solid rgba(255,255,255,0.08)" }}>
        <button onClick={() => navigate('/')} style={{ display: "flex", alignItems: "center", gap: 10, background: "none", border: "none", cursor: "pointer" }}>
          <div style={{ width: 32, height: 32, borderRadius: 9, background: "linear-gradient(135deg,#7F77DD,#1D9E75)", display: "flex", alignItems: "center", justifyContent: "center" }}>
            <span style={{ color: "#fff", fontWeight: 700, fontSize: 16 }}>F</span>
          </div>
          <span style={{ fontSize: 18, fontWeight: 700, letterSpacing: "-0.5px", color: "#f0efe9" }}>FLO</span>
        </button>
        <div style={{ display: "flex", gap: 10 }}>
          <button onClick={() => navigate('/login')} style={{ padding: "7px 16px", borderRadius: 8, border: "0.5px solid rgba(255,255,255,0.15)", background: "transparent", color: "#f0efe9", fontSize: 13, cursor: "pointer" }}>Log in</button>
          <button onClick={() => navigate('/signup')} style={{ padding: "7px 16px", borderRadius: 8, border: "none", background: "#534AB7", color: "#fff", fontSize: 13, cursor: "pointer", fontWeight: 500 }}>Get started</button>
        </div>
      </nav>

      <div style={{ textAlign: "center", padding: "70px 24px 50px" }}>
        <h1 style={{ fontSize: "clamp(32px,5vw,52px)", fontWeight: 700, letterSpacing: "-1.5px", marginBottom: 14 }}>Simple, transparent pricing</h1>
        <p style={{ fontSize: 16, color: "rgba(240,239,233,0.55)", maxWidth: 440, margin: "0 auto" }}>No setup fees. No contracts. Cancel anytime. All plans include a 14-day free trial.</p>
      </div>

      <div style={{ maxWidth: 1060, margin: "0 auto", padding: "0 24px 100px", display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(280px,1fr))", gap: 20 }}>
        {PLANS.map(plan => (
          <div key={plan.name} style={{ borderRadius: 16, border: plan.highlight ? "1.5px solid #534AB7" : "0.5px solid rgba(255,255,255,0.1)", background: plan.highlight ? "rgba(83,74,183,0.08)" : "rgba(255,255,255,0.03)", padding: "28px 26px", position: "relative", display: "flex", flexDirection: "column" }}>
            {plan.highlight && (
              <div style={{ position: "absolute", top: -12, left: "50%", transform: "translateX(-50%)", padding: "3px 14px", borderRadius: 20, background: "#534AB7", fontSize: 11, fontWeight: 600, color: "#fff", whiteSpace: "nowrap" }}>
                Most popular
              </div>
            )}
            <div style={{ marginBottom: 20 }}>
              <div style={{ fontSize: 14, fontWeight: 600, color: plan.color === "#534AB7" ? "#AFA9EC" : plan.color, marginBottom: 8 }}>{plan.name}</div>
              <div style={{ display: "flex", alignItems: "baseline", gap: 2, marginBottom: 10 }}>
                <span style={{ fontSize: 42, fontWeight: 700, letterSpacing: "-2px" }}>{plan.price}</span>
                <span style={{ fontSize: 14, color: "rgba(240,239,233,0.4)" }}>{plan.period}</span>
              </div>
              <div style={{ fontSize: 13, color: "rgba(240,239,233,0.5)", lineHeight: 1.5 }}>{plan.desc}</div>
            </div>
            <button onClick={() => navigate('/signup', { state: { plan: plan.name } })} style={{ padding: "11px", borderRadius: 9, border: plan.highlight ? "none" : "0.5px solid rgba(255,255,255,0.15)", background: plan.highlight ? "#534AB7" : "transparent", color: "#f0efe9", fontSize: 14, cursor: "pointer", fontWeight: 600, marginBottom: 24 }}>
              Start 14-day free trial
            </button>
            <div style={{ display: "flex", flexDirection: "column", gap: 10, flex: 1 }}>
              {plan.features.map(f => (
                <div key={f} style={{ display: "flex", alignItems: "center", gap: 10, fontSize: 13, color: "rgba(240,239,233,0.75)" }}>
                  <i className="ti ti-check" style={{ fontSize: 14, color: "#1D9E75", flexShrink: 0 }} aria-hidden="true" />
                  {f}
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}